export default __webpack_public_path__ + "static/media/sell-trade.14717b14.svg";